<template>
  <div>
    <h4>Порядок слов в предложении Satzbau</h4>

    <h5 class="indigo-text text-darken-1">Главное предложение</h5>
    <p>Главные предложения независимы.</p>

    <h6 class="fontbold">Повествовательное предложение</h6>
    <p>Что-либо рассказывается, сообщается или утверждается.</p>
    <blockquote>Ich habe Ihn erst gestern kennen gelernt.</blockquote>

    <h6 class="fontbold">Вопросительное предложение</h6>
    <p>Чтобы получить какие-либо сведения.</p>

    <div class="row">
      <div class="col s12 m10 l8">
        <table>
          <tbody>
            <tr>
              <td>
                W-Fragen
                <br />(Дополнительные вопросы)
              </td>
              <td>
                начинается с вопросительного слова:
                <br />wann, warum, weshalb, wie, ...
                <br />Woher kennst du mich ?
              </td>
            </tr>

            <tr>
              <td>
                Ja/Nein-Fragen
                <br />(Вопросы принятия решений)
              </td>
              <td>
                на них отвечают да или нет
                <br />Kennen Sie sich bereits? - Ja. / Nein.
              </td>
            </tr>

            <tr>
              <td>Отрицающие Ja/Nein-Fragen</td>
              <td>
                на них отвечают nein или doch
                <br />Glaubst du mir nicht? - Nein. / Doch.
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <h6 class="fontbold">Повелительное предложение (Императив)</h6>
    <p>Формулируются приказы, просьбы или желания.</p>
    <blockquote>
      Geben Sie mir die Hand!
      <br />Bitte, sprechen Sie jetzt!
    </blockquote>

    <h5 class="indigo-text text-darken-1">Подчинённое предложение</h5>
    <p>Подчинённые предложения всегда зависимы от главного предложения.</p>

    <p>Многие подчинённые предложения образуются при помощи союзов.</p>
    <blockquote>Ich glaube, dass er Fieber hat.</blockquote>

    <p>
      Подчинённые предложения, образованные при помощи относительных местоимений, проясняют
      существительное или местоимение главного предложения.
      Перед относительным местоимением может стоять предлог.
    </p>
    <blockquote>
      Maurits, der heute Geburtstag hat, freut sich sehr.
      <br />Das ist Klaus, mit dem ich im Urlaub war.
    </blockquote>

    <p>
      Подчинённые предложения, образованные при помощи W-слов (wer, wen, wessen, was, wann, wo, wohin, woher, wie, warum, welche),
      часто являются непрямыми вопросами.
    </p>
    <blockquote>Keiner weiß, wohin sie gegangen ist und wen sie getroffen hat.</blockquote>

    <p>Подчинённые предложения с zu + инфинитив имеют часто субъект главного предложения.</p>
    <blockquote>Ich habe heute keine Zeit, mit dir zu spielen.</blockquote>

    <p>Подчинённые предложения часто образуются со словами um, ohne и anstatt... (zu).</p>
    <blockquote>Er fuhr nach Paris, um sich die Picasso-Ausstellung anzusehen.</blockquote>

    <h5 class="indigo-text text-darken-1">Позиция глагола в предложении</h5>

    <h6 class="fontbold">Повествовательные предложения и W-Fragen</h6>

    <div class="row">
      <div class="col s12 m12 l8">
        <table>
          <tbody>
            <tr>
              <td>1. позиция</td>
              <td>
                2. позиция
                <br />глагол №1
              </td>
              <td>
                середина
                <br />прочие члены предложения
              </td>
              <td>
                конец
                <br />глагол №2
              </td>
            </tr>

            <tr>
              <td>Anne und Felix</td>
              <td>hören</td>
              <td>Musik.</td>
              <td></td>
            </tr>

            <tr>
              <td>Die Studentin</td>
              <td>hört sich</td>
              <td>einen Vortrag</td>
              <td>an.</td>
            </tr>

            <tr>
              <td>Sie</td>
              <td>kann</td>
              <td>ihn nicht</td>
              <td>hören.</td>
            </tr>

            <tr>
              <td>Der müde Vater</td>
              <td>hat</td>
              <td>ihm nicht</td>
              <td>zugehört.</td>
            </tr>

            <tr>
              <td>Warum</td>
              <td>hast</td>
              <td>du mir nicht</td>
              <td>zugehört?</td>
            </tr>

            <tr>
              <td>Was</td>
              <td>willst</td>
              <td>du</td>
              <td>hören?</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <h6 class="fontbold">Повелительные предложения и Ja/Nein-Fragen</h6>

    <div class="row">
      <div class="col s12 m12 l6">
        <table>
          <tbody>
            <tr>
              <td>
                1. позиция
                <br />глагол №1
              </td>
              <td>
                субъект
                <br />и прочие члены предложения
              </td>
              <td>
                конец
                <br />глагол №2
              </td>
            </tr>

            <tr>
              <td>Hören</td>
              <td>Sie mich?</td>
              <td></td>
            </tr>

            <tr>
              <td>Hör</td>
              <td>doch endlich damit</td>
              <td>auf!</td>
            </tr>

            <tr>
              <td>Könntest</td>
              <td>du mich erst mal</td>
              <td>an hören?</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <p>
      Глагол №1 это всегда спрягаемый глагол, который находится на позиции 1. или 2.
      Глагол №2 всегда в конце. Здесь могут быть например отделяемые приставки,
      причастие два при Perfekt или Passiv или инфинитив при модальной форме.
    </p>

    <h6 class="fontbold">Подчинённые предложения</h6>

    <p>
      В подчинённом предложении все глаголы и их части стоят в конце предложения.
      При многочастной глагольной форме, спрягаемый глагол стоит всегда в конце.
    </p>

    <div class="row">
      <div class="col s12 m12 l8">
        <table>
          <tbody>
            <tr>
              <td>Главное предложение</td>
              <td>Подчинённое предложение</td>
            </tr>

            <tr>
              <td>Ich habe dich gefragt,</td>
              <td>ob du mich gut hörst.</td>
            </tr>

            <tr>
              <td>Er ist glücklich,</td>
              <td>dass er wieder hören kann.</td>
            </tr>

            <tr>
              <td>Das ist der Hund,</td>
              <td>der auf den Namen Balu hört.</td>
            </tr>

            <tr>
              <td>Ich kann jetzt nicht,</td>
              <td>
                weil ich ihn Vokabeln abhöre.
                <br />(приставка глаголов с отделямыми приставками не отделяется!)
              </td>
            </tr>

            <tr>
              <td>Weißt du,</td>
              <td>wo der Kurs stattfindet?</td>
            </tr>

            <tr>
              <td>Du sagst das nur,</td>
              <td>um mich zu beruhigen.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <h6 class="fontbold">Отрицание в предложении</h6>

    <p>„Nicht" ставится в основном в конце предложения. Но есть следующие исключения:</p>

    <div class="row">
      <div class="col s12 m12 l8">
        <table>
          <tbody>
            <tr>
              <td>Ich</td>
              <td>komme</td>
              <td>nicht.</td>
              <td></td>
              <td></td>
            </tr>

            <tr>
              <td>Thomas</td>
              <td>ruft</td>
              <td>nicht</td>
              <td>an.</td>
              <td>Двухчастная глагольная форма</td>
            </tr>

            <tr>
              <td>Er</td>
              <td>ist</td>
              <td>nicht</td>
              <td>da.</td>
              <td>sein + наречие</td>
            </tr>

            <tr>
              <td>Till</td>
              <td>ist</td>
              <td>nicht</td>
              <td>ihr Onkel.</td>
              <td>sein + существительное</td>
            </tr>

            <tr>
              <td>Opa</td>
              <td>ist</td>
              <td>nicht</td>
              <td>alt.</td>
              <td>sein + прилагательное</td>
            </tr>

            <tr>
              <td>Mutter</td>
              <td>fährt</td>
              <td>nicht</td>
              <td>schnell.</td>
              <td>наречие как</td>
            </tr>

            <tr>
              <td>Sie</td>
              <td>fliegt</td>
              <td>nicht</td>
              <td>über Prag.</td>
              <td>объект + предлог</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <h6 class="fontbold">Позиция подчинённого предложения</h6>

    <div class="row">
      <div class="col s12 m12 l12">
        <table>
          <tbody>
            <tr>
              <td>Как правило подчинённое предложение стоит после главного.</td>
              <td>Wir waren am Strand, als der Sturm kam.</td>
            </tr>

            <tr>
              <td>
                При конструкциях с инфинитивом с um, ohne, anstatt ...zu
                и некоторых союзах (da, während, wenn, nachdem, seitdem, obwohl)
                подчинённое предложение может стоять на первом месте.
                Тогда в главном предложении глагол стоит на первом месте.
              </td>
              <td>
                Da es regnen soll, nehme ich den Schirm mit.
                Ohne mich zu beachten, verließ er den Raum.
              </td>
            </tr>

            <tr>
              <td>
                Подчинённое предложение находится внутри главного.
                Это возникает прежде всего при относительных местоимениях и конструкциях с инфинитивом.
              </td>
              <td>
                Der Schirm, den ich mitgenommen habe, hat leider ein Loch.
                Sie las den Brief, um ganz sicher zu sein, noch einmal.
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>


<style scoped>
.fontbold {
  font-weight: bold;
}
td {
  padding: 2px 2px;
}
</style>


<script>
export default {
  name: "grammatik_satzbau",
  data: () => ({}),
  computed: {}
};
</script>
